module.exports = __webpack_public_path__ + "static/media/agriLands.6cfd6296.jpeg";